import springCenfApi from '../../services/springCenfApi'

export const storeDownloadToken = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/download_tokens', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)